import type { ColumnDef, Row, Table as TanStackTable } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import React from "react";

interface DataTableMobileCardProps<TData> {
  table: TanStackTable<TData>;
  columns: ColumnDef<TData>[];
  renderCard?: (row: Row<TData>) => React.ReactNode;
}

function DefaultCard<TData>({ row }: { row: Row<TData> }) {
  const visibleCells = row.getVisibleCells();

  return (
    <div className="border border-base-300 rounded-box p-3 bg-base-100">
      {visibleCells.map((cell) => {
        // Skip selection checkbox cell
        if (cell.column.id === "select") return null;

        const header = cell.column.columnDef.header;
        const headerText = typeof header === "string" ? header : cell.column.id;

        return (
          <div
            key={cell.id}
            className="flex justify-between items-center py-1.5 border-b border-base-200 last:border-b-0"
          >
            <span className="text-xs font-semibold text-base-content/60 uppercase tracking-wider">
              {headerText}
            </span>
            <span className="text-sm text-right ml-2">
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export function DataTableMobileCard<TData>({
  table,
  columns,
  renderCard,
}: DataTableMobileCardProps<TData>) {
  const rows = table.getRowModel().rows;

  if (!rows.length) return null;

  return (
    <div className="flex flex-col gap-2 lg:hidden">
      {rows.map((row) => (
        <React.Fragment key={row.id}>
          {renderCard ? renderCard(row) : <DefaultCard row={row} />}
        </React.Fragment>
      ))}
    </div>
  );
}
